module.exports = __webpack_public_path__ + "static/desktop/img/production-album.602bcc5e.png";